import React, { } from 'react';
import DatosLibrosPropios from './DatosLibrosPropios';
import { TipoSeccionLibrosEstadisticas } from '@/objects/Telemetry';
import LibrosEstadisticasLista from './LibrosEstadisticasLista';
import { IDAdsense, SlotAnuncioDisplay } from '@/util/BaseURL';
import GoogleAds, { AdSenseFormat } from '../../Adsense/GoogleAds';

function EstadisticasPropias() {

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {/* <TituloPrincipalH1 texto={t("menu:secciones.mensajes.titulo")} /> */}
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                <div>
                    <GoogleAds client={IDAdsense} slot={SlotAnuncioDisplay} format={AdSenseFormat.HORIZONTAL} dataFullWidthResponsive={true} />
                </div>
                <DatosLibrosPropios />
                <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.LIBROS_PROPIOS_POPULARES} />
                <div>
                    <GoogleAds client={IDAdsense} slot={SlotAnuncioDisplay} format={AdSenseFormat.HORIZONTAL} dataFullWidthResponsive={true} />
                </div>
                <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.LIBROS_MAS_FAVORITOS_PROPIOS} />
            </section>
        </section>
    );
}

export default EstadisticasPropias;